export default "__VITE_ASSET__D787r2uk__"